export const config = {
  API: process.env.VUE_APP_API,
  SEO_API: process.env.VUE_APP_API
  // SEO_API: `http://api.vinchecker.com.dev11.vintagedev.com.ua`
};
